import useApi from "components/hooks/useApi";
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ActionTypes from "redux/actions/types";
import { RootState } from "redux/reducers";
import { getBranchesByUser } from "services/organization";
import { Options } from "utils/helper/types";

const BranchContext = createContext<{defaultBranch : string, branches : Options} | null>(null);

export const BranchProvider = ({ children }) => {
    const dispatch = useDispatch();
    const use_role_level = localStorage.getItem("use_role_level");
    const userId = localStorage.getItem("userId");
    const branchId = localStorage.getItem("branchId");
    const smrId = useSelector((state : RootState) => state.organization.smrId);
    const permissions = useSelector((state : RootState) => state.user.permissions);

    const [branch, setBranch] = useState("");

      // Extract SubmoduleId from permissions based on path
    React.useEffect(() => {
        if(permissions?.length){
            const locationArray = window.location.pathname.split("/");
            const currentLocation = locationArray[locationArray.length - 1]
            permissions.map((module) => {
                if(!module.module) {
                    return;   
                }
                const routePath = module.module.route_path;
                if(routePath.includes(currentLocation)){
                    dispatch({type : ActionTypes.UPDATE_SMR_ID,payload : module.module._id});
                }
            });
        }
    }, [permissions]);


    useEffect(() => {
        if(use_role_level === "branch" && branchId){
            setBranch(branchId);
        }
    }, [use_role_level, branchId])

    useEffect(() => {
        if (userId && smrId) {
          getBranchesAction({ userId, moduleId: smrId });
        }
    }, [smrId, userId]);

    const { action: getBranchesAction, data: branchesResponse } = useApi(
        getBranchesByUser
    );

    const branches: Options = useMemo(() => {
    return (branchesResponse?.data ?? []).map((branch) => {
        return {
        label: branch.branch_name,
        value: branch._id,
        };
    });
    }, [branchesResponse?.data]);

    return (
        <BranchContext.Provider value={{defaultBranch : branch, branches}}>
            {children}
        </BranchContext.Provider>
    );
};

export const useBranch = () => useContext(BranchContext);
